import useTracksStore from '../tracks.store.tsx'
import { useHistoryStore } from '../history.store.tsx'

export const addMediaFileTrack = (): void => {
  useTracksStore.getState().addMediaFileTrack()
  useHistoryStore.getState().saveSnapshot()
}
